import { render, staticRenderFns } from "./ListMenuPage.vue?vue&type=template&id=79398989"
import script from "./ListMenuPage.vue?vue&type=script&lang=js"
export * from "./ListMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports